<section class="claim-updates-container bolt-container">
    <div class="bolt-heading-md bolt-space-bottom-lg">Claim updates</div>

    <bolt-waiting-indicator class="bolt-space-inner-xl bolt-space-bottom-lg" *ngIf="updatesState === ClaimUpdatesStateEnum.LOADING">Loading update information...
    </bolt-waiting-indicator>

    <div *ngIf="updatesState === ClaimUpdatesStateEnum.HAS_UPDATES" class="claim-updates-list">
        <div *ngFor="let update of claimUpdates" class="claim-update-item bolt-space-bottom-lg">
            <div class="bolt-row bolt-no-gutters">
                <div class="bolt-col-auto bolt-space-right-lg">
                    <img
                        [src]="'../../../../assets/icons/' + update.iconName + '.svg'"
                        alt=""
                        width="32"
                        height="32">
                </div>
                <div class="bolt-col update-message-container">
                    <div class="update-message">
                        <span class="update-event-name bolt-body-md bolt-body-font-weight-medium">{{ update.eventName }}: </span>
                        <span class="bolt-body-md">{{ update.description }}</span>
                    </div>
                    <div class="update-date bolt-subheading-sm bolt-space-top-sm">
                        {{ update.eventDate | date: 'MMMM d, yyyy' }}
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="updatesState === ClaimUpdatesStateEnum.NO_UPDATES" class="claim-updates-no-data">
        <p class="bolt-body-copy-lg">No claim updates are available at this time.</p>
    </div>

    <bolt-notification  *ngIf="updatesState === ClaimUpdatesStateEnum.ERROR"  type="error" class="bolt-space-bottom-lg">
        Your claim updates didn't load. We'll get it fixed.
    </bolt-notification>
</section>
